<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import { escapeHtml } from "@kontextwerk/web-sdk/core/security"
  import {
    propertyCustomerRoleOptions,
    formatPropertyCustomerRole,
  } from "../../../../../../../../../_shared/_logic/customer-roles"
  import type { ContactPersonDraft } from "../../_logic/contact-comparison"
  let {
    value = $bindable(),
    original,
    disabled = false,
    nameReadOnly = false,
    roleRequired = false,
    hints = {},
  }: {
    value: ContactPersonDraft
    original: ContactPersonDraft
    disabled?: boolean
    nameReadOnly?: boolean
    roleRequired?: boolean
    hints?: Partial<Record<keyof ContactPersonDraft, string>>
  } = $props()
  const id = $props.id()
  const fields = [
    { key: "displayName", label: "Name", type: "text" },
    { key: "role", label: "Rolle", type: "select" },
    { key: "email", label: "E-Mail", type: "email" },
    { key: "phone", label: "Telefon", type: "tel" },
  ] as const
</script>
<section class="contact-person-form" aria-label="Neue Angaben">
  <ActionBox label="Neue Angaben" darkMode={false}>
  <div class="form light">
  <div class="row contact-fields">
  {#each fields as field}
      <Input
            id={`${id}-${field.key}`}
            style="width: 100%; min-width: 0;"
            label={field.label}
            placeholder={field.label}
            type={field.type}
            bind:value={value[field.key]}
            options={field.key === "role" ? propertyCustomerRoleOptions : []}
            surfaceTone="light"
            brightBackground={true}
            disabled={disabled || (field.key === "displayName" && nameReadOnly)}
            tooltip={escapeHtml(
              hints[field.key] ||
                (original[field.key]
                  ? `Vom Kunden genannt: ${field.key === "role" ? formatPropertyCustomerRole(original[field.key]) : original[field.key]}`
                  : "Vom Kunden nicht genannt"),
            )}
            required={field.key === "displayName" || (field.key === "role" && roleRequired)}
          />
  {/each}
  </div>
  </div>
  </ActionBox>
</section>
<style>
  .contact-person-form {
    width: 100%;
    min-width: 0;
    container-type: inline-size;
  }
  .contact-person-form :global(.box) {
    width: 100%;
    min-width: 0;
    height: auto;
    box-sizing: border-box;
    border-color: color-mix(in srgb, var(--text-invers-100) 25%, transparent);
  }
  .contact-person-form .contact-fields {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }
  @container (max-width: 420px) {
    .contact-person-form .contact-fields {
      grid-template-columns: 1fr;
    }
  }
</style>
